import { render, staticRenderFns } from "./FcMonthRewards.vue?vue&type=template&id=c9c4fb20&scoped=true"
import script from "./FcMonthRewards.vue?vue&type=script&lang=js"
export * from "./FcMonthRewards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c4fb20",
  null
  
)

export default component.exports